import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly key = 'theme';
  private current: 'light' | 'dark' = 'light';
  private readonly root = document.documentElement;

  constructor() {
    const saved = localStorage.getItem(this.key) as 'light' | 'dark' | null;
    if (saved === 'light' || saved === 'dark') {
      this.current = saved;
    } else if (this.root.classList.contains('dark')) {
      this.current = 'dark';
    }

    this.applyTheme(this.current);
  }

  toggle(): void {
    this.setTheme(this.current === 'light' ? 'dark' : 'light');
  }

  setTheme(theme: 'light' | 'dark'): void {
    this.current = theme;
    this.applyTheme(theme);
    localStorage.setItem(this.key, theme);
  }

  isDark(): boolean {
    return this.current === 'dark';
  }

  private applyTheme(theme: 'light' | 'dark'): void {
    this.root.classList.remove('light', 'dark');
    this.root.classList.add(theme);
    this.root.style.colorScheme = theme;
  }
}
